import { SignIn, Info } from "@phosphor-icons/react";

export function DemoBanner({ onSignIn }: { onSignIn: () => void }) {
  return (
    <div className="flex items-center justify-between gap-3 px-3 py-1.5 bg-[var(--color-lever-peach)]/8 border-b border-[var(--color-lever-peach)]/15">
      <div className="flex items-center gap-2 min-w-0">
        <Info size={13} weight="bold" className="text-[var(--color-lever-peach)] shrink-0" />
        <span className="text-[11px] text-[var(--text-secondary)] truncate">
          Demo mode &mdash; edits are local only. Sign in to save your work and unlock all features.
        </span>
      </div>
      <button
        onClick={onSignIn}
        className="flex items-center gap-1.5 rounded-[var(--radius-sm)] px-2.5 py-1 text-[10px] font-medium
          bg-[var(--text-primary)] text-[var(--text-inverse)]
          hover:opacity-90 transition-opacity duration-75 shrink-0"
      >
        <SignIn size={11} weight="bold" />
        Sign in
      </button>
    </div>
  );
}
